import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { DEFAULT_TABLE_ROWS_PER_PAGE } from '../../../utils/formValidation/commonConstants';
import { stableSort } from '../../../utils/sortFunctions';
import { uuid } from '../../../utils/stringUtils';
import ResultsTable from '../../table/ResultsTable';

import TimelineEventHistoryTableRow from './TimelineEventHistoryTableRow';

const headCells = [
    { id: 'field', numeric: false, label: 'Field' },
    { id: 'from', numeric: false, label: 'From' },
    { id: 'to', numeric: false, label: 'To' }
];

const initialRowMetaData = {
    order: 'desc',
    orderBy: 'field',
    page: 0,
    rowsPerPage: DEFAULT_TABLE_ROWS_PER_PAGE
};

const TimelineEventHistoryManagement = ({ eventHistory = [] }) => {
    // LOCAL STATE
    const [rows, setRows] = useState([]);
    const [rowMetaData, setRowMetaData] = useState(initialRowMetaData);

    // HELPER FUNCTIONS
    const createRows = () => {
        return stableSort(rows, rowMetaData.orderBy, rowMetaData.order).map((el) => (
            <TimelineEventHistoryTableRow key={uuid()} row={el} />
        ));
    };

    // USE EFFECTS
    useEffect(() => {
        if (!eventHistory?.length > 0) return;
        setRows(eventHistory);
    }, []);

    // RENDER
    return rows.length < 1 ? (
        <div>No timeline event history found</div>
    ) : (
        <div>
            <ResultsTable
                defaultOrderBy={rowMetaData.orderBy}
                sortOrder={rowMetaData.order}
                defaultRowsPerPage={DEFAULT_TABLE_ROWS_PER_PAGE}
                headCells={headCells}
                loadResults={rows}
                passRowMetaDataUp={setRowMetaData}
                tableRows={createRows()}
                totalResults={rows.length}
            />
        </div>
    );
};

TimelineEventHistoryManagement.propTypes = {
    eventHistory: PropTypes.array
};

export default TimelineEventHistoryManagement;
